import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-wrapper" }
const _hoisted_2 = { class: "grid grid-nogutter layout-main-container" }
const _hoisted_3 = { class: "layout-app-sidebar" }
const _hoisted_4 = { class: "layout-app" }
const _hoisted_5 = { class: "layout-app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar_app = _resolveComponent("sidebar-app")!
  const _component_NavbarApp = _resolveComponent("NavbarApp")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_sidebar_app, {
          menus: _ctx.sidebarItems,
          isOpen: _ctx.isOpen,
          showmenu: _ctx.showmenu
        }, null, 8, ["menus", "isOpen", "showmenu"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NavbarApp),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_view, { class: "col" })
        ])
      ])
    ])
  ]))
}